import React from 'react';
import { Chip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid } from '../grid';
import CoverageTimeline from './CoverageTimeline';

type Props = { rows: any[]; loading?: boolean };

class BaselineCoverageGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'variablecode', headerName: 'Variable', width: 150 },
    { field: 'variablename', headerName: 'Name', flex: 1, minWidth: 220 },
    { field: 'datasetcode', headerName: 'Dataset', width: 140 },
    { field: 'source', headerName: 'Source', width: 170 },
    { field: 'continuousto', headerName: 'Continuous To', width: 140 },
    { field: 'forecaststart', headerName: 'Forecast Start', width: 140 },
    { field: 'missingperiods', headerName: 'Missing', width: 170, renderCell: (p) => (p.value || []).length ? <Typography variant="body2" color="error.main" sx={{ fontWeight: 700 }}>{(p.value || []).join(', ')}</Typography> : <Typography variant="body2" color="success.main" sx={{ fontWeight: 700 }}>None</Typography> },
    { field: 'readiness', headerName: 'Readiness', width: 120, renderCell: (p) => <Typography variant="body2" sx={{ fontWeight: 800 }}>{Number(p.value || 0)}%</Typography> },
    { field: 'status', headerName: 'Status', width: 120, renderCell: (p) => <Chip size="small" label={p.value || '-'} color={p.value === 'READY' ? 'success' : p.value === 'BLOCKED' ? 'error' : 'warning'} /> },
    { field: 'periods', headerName: 'Coverage Timeline', flex: 1, minWidth: 360, sortable: false, renderCell: (p) => <CoverageTimeline periods={p.value || []} /> },
  ];

  getRowId = (row: any) => row.variablecode || row.datasetcode;

  render() {
    return (
      <FGrid
        title="Baseline Coverage Details"
        subtitle="Descending timeline shows approved facts, missing facts, forecast values and future periods."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={520}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={this.getRowId}
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        getRowClassName={(p: any) => p.row.status === 'BLOCKED' ? 'blocked-row' : p.row.status === 'WARNING' ? 'warning-row' : ''}
        sx={{ '& .blocked-row': { bgcolor: '#ffebee' }, '& .warning-row': { bgcolor: '#fff8e1' } }}
      />
    );
  }
}

export default BaselineCoverageGrid;
